module.exports = __webpack_public_path__ + "img/vertical_7_2_8019.d10c99d9.png";